var mixin = {
  methods: {
    humanizedSwitch: function (value, trueValue, falseValue) {
      return value ? (trueValue != null ? trueValue : 'Yes') : (falseValue != null ? falseValue : 'No')
    }
  }
}

export default mixin
